import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-progressbar-page-ui',
    templateUrl: './bb-progressbar-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbProgressbarPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
